<template lang="pug">
  .cabinet
    .section
      .container
        .columns
          .column.is-three-quarters.invoices-block
            .card
              .card-header
                p.card-header-title {{gettext('Invoices')}}
              .card-content
                table.table.is-fullwidth.is-hoverable(v-if="(invoices.items || {}).length")
                  thead
                    tr
                      th #
                      th {{gettext('Created')}}
                      th {{gettext('Expire')}}
                      th {{gettext('Amount')}}
                      th {{gettext('Status')}}
                      th {{gettext('Action')}}
                  tbody
                    tr(v-for="invoice in invoices.items")
                      th {{invoice.id}}
                      td.has-text-centered
                        span.wide-txt {{invoice.created | date}}
                        span.wide-txt
                          | (
                          time-ago(:date="invoice.created")
                          | )
                      td.has-text-centered {{invoice.expire | date}}
                       .wide-txt ({{expiredFormat(invoice.expire)}})
                      td {{invoice.amount}} ({{invoice.payment_info.residue.amount}})
                      td {{ getStatus(invoice) }}
                      td
                        button.button.btn-pay(
                          v-if="(invoice.status || {}).code === CONSTANTS.INVOICE_STATUS_PENDING"
                          @click="pay(invoice.id)"
                        ) {{gettext('Pay')}}
                        button.button.btn-cansel(
                          v-if="(invoice.status || {}).code === CONSTANTS.INVOICE_STATUS_PENDING"
                          @click="confirmModal = true, invoiceID = invoice.id"
                        ) {{gettext('Cancel')}}
                        button.button.btn-details(@click="getDetail(invoice.id)") {{gettext('Details')}}
                  tfoot
                    tr
                      th #
                      th {{gettext('Created')}}
                      th {{gettext('Expire')}}
                      th {{gettext('Amount')}}
                      th {{gettext('Status')}}
                      th {{gettext('Action')}}
                .has-text-centered(v-else)
                  loading(v-if="loading")
                  .content.is-fluid(v-else)
                    .notification
                      .has-text-centered.is-size-4 {{ gettext('You have no invoices!') }}
          .column.is-one-quarter.account-block
            finance-account
        vue-paginate(
          v-if="invoices.total_items"
          :page-count="invoices.total_pages"
          :page-range="3"
          :initial-page="currentPage-1"
          :clickHandler="toPage"
        )
      v-modal(:show.sync="confirmModal" :clickAway="true")
        section.modal-card-body
          .is-size-4.has-text-centered.title {{ gettext('Are you sure you want to cancel the invoice?') }}
          .btn-wrap
            button.main-btn.col-white.bg-red.nav-item.is-tab(@click="cancel(invoiceID)") {{ gettext('Yes. Cancel invoice') }}
            button.main-btn.col-white.bg-black.nav-item.is-tab(@click="confirmModal = false") {{ gettext('No') }}

      v-modal.details-modal(:show.sync="detailsModal" :clickAway="false" v-if="invoiceDetail")
        header.modal-card-head
          p {{gettext('Invoice')}} # {{invoiceDetail.invoice.id}} / {{getStatus(invoiceDetail.invoice)}}
        section.modal-card-body.details-wrap
          strong {{gettext('Items')}}
          table.table.is-fullwidth
            tbody
              tr
                v-accordion(v-for="(item, index) in invoiceDetail.items" :key="index")
                  template(slot="header")
                    .item-header
                      div {{getAlias(item.type)}}
                      div {{item.amount}} &euro;
                  .item-body(v-if="item.type === CONSTANTS.CV_INVOICE_ITEM_NAME")
                    table.table.table-descr.is-fullwidth
                      thead
                        tr
                          th {{gettext('Description')}}
                          th {{gettext('Expiration time')}}
                          th {{gettext('Hits number')}}
                      tbody
                        tr
                          td {{item.description}}
                          td {{interpolate(ngettext('%s day', '%s days', item.expiration_time), [item.expiration_time])}}
                          td {{item.hits_number}}
                  .item-body(v-if="item.type === CONSTANTS.ACCOUNT_TOPUP_INVOICE_NAME")
                    table.table.table-descr.is-fullwidth
                      thead
                        tr
                          th {{gettext('Description')}}
                      tbody
                        tr
                          td {{item.description}}
                  .item-body(v-if="item.type === CONSTANTS.PERSONAL_MATCH_TYPE_NAME || item.type === CONSTANTS.PAPER_WORK_TYPE_NAME")
                    table.table
                      tbody
                        tr
                          td {{gettext('Employer from')}}
                          td {{countries.find(x => x.id === item.employer_country_id).name}}
                        tr
                          td {{gettext('Employee from')}}
                          td {{countries.find(x => x.id === item.jobseeker_country_id).name}}
          div
            strong {{gettext('Invoice details')}}
            table.table.is-fullwidth
              tbody
                tr
                  td {{gettext('Invoice amount')}}
                  td {{invoiceDetail.invoice.amount}} &euro;
                tr
                  td {{gettext('Vat percent')}}
                  td {{invoiceDetail.invoice.vat_percent}} %
                tr
                  td {{gettext('Vat amount')}}
                  td {{invoiceDetail.invoice.amount_vat}} &euro;
                tr
                  th {{gettext('Total amount')}}
                  th {{invoiceDetail.invoice.amount_total}} &euro;
                tr
                  td {{gettext('Created')}}
                  td {{invoiceDetail.invoice.created | date}}
                tr
                  td {{gettext('Expire')}}
                  td {{invoiceDetail.invoice.expire | date}}
          hr
          div
            strong {{gettext('Payment details')}}
            table.table.is-fullwidth
              thead
                tr
                  th #
                  th {{gettext('Amount')}}
                  th {{gettext('Vat')}}
                  th {{gettext('Total')}}
              tbody
                tr
                  th {{gettext('Payed')}}
                  td {{invoiceDetail.invoice.payment_info.payed.amount}}
                  td {{invoiceDetail.invoice.payment_info.payed.vat}}
                  th {{invoiceDetail.invoice.payment_info.payed.total}}
                tr
                  th {{gettext('Residue')}}
                  td {{invoiceDetail.invoice.payment_info.residue.amount}}
                  td {{invoiceDetail.invoice.payment_info.residue.vat}}
                  th {{invoiceDetail.invoice.payment_info.residue.total}}
          hr(v-if="(invoiceDetail.payments || {}).length")
          v-accordion(v-if="(invoiceDetail.payments || {}).length")
            template(slot="header")
              .item-header
                div
                  strong {{gettext('Show payments')}}
                div {{interpolate(ngettext('%s item', '%s items', (invoiceDetail.payments || {}).length),[(invoiceDetail.payments || {}).length])}}
            div
              table.table.is-fullwidth
                thead
                  tr
                    th #
                    th {{gettext('Amount')}}
                    th {{gettext('Pay method')}}
                    th {{gettext('Created')}}
                    th {{gettext('Expire')}}
                    th {{gettext('Status')}}
                tfoot
                  tr
                    th #
                    th {{gettext('Amount')}}
                    th {{gettext('Pay method')}}
                    th {{gettext('Created')}}
                    th {{gettext('Expire')}}
                    th {{gettext('Status')}}
                tbody
                  tr(v-for="payment in invoiceDetail.payments")
                    th {{payment.id}}
                    td {{payment.amount}}
                    td {{payment.paymethod_name}}
                    td {{payment.created | date}}
                    td {{payment.expire | date}}
                    td {{payment.status.name}}
        footer.modal-card-foot
          button.main-btn.col-white.bg-black.nav-item.is-tab(@click="detailsModal = false") {{ gettext('Close') }}

</template>
<script>

import { gettext, interpolate, ngettext } from '@/services/TranslateHandler'
import { mapGetters, mapActions } from 'vuex'
import VuePaginate from '@/components/paginate'
import Loading from '@/components/stretch-spinner'
import VModal from '@/components/modal'
import TimeAgo from '@/components/time-ago'
import VAccordion from './components/accordion'
import FinanceAccount from './parts/finance-account'
import mixin from '@/mixins'

const moment = require('moment')
const toastr = require('toastr')
const CONSTANTS = require('@/constants.json')
const _ = require('lodash')

export default {
  name: 'BillingCabinet',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    VuePaginate,
    Loading,
    VModal,
    TimeAgo,
    VAccordion,
    FinanceAccount
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      invoices: {},
      currentPage: parseInt(this.$route.query.page) || 1,
      pageSize: 15,
      loading: true,
      confirmModal: false,
      detailsModal: false,
      invoiceDetail: null,
      aliases: {},
      countries: []
    }
  },
  filters: {
    date: function (val) {
      return moment(val).format('DD/MM/YYYY')
    },
    timeLeft: function (val) {
      return moment(val)
    }
  },
  methods: {
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    ...mapActions([
      'getBillingInvoices',
      'createInvoice',
      'cancelInvoice',
      'getBillingInvoiceDetail',
      'receiveCountries'
    ]),
    getData: function (page) {
      this.loading = true
      this.getBillingInvoices({
        lang: this.getLanguage,
        account: this.getFinanceAccount,
        page: page,
        size: this.pageSize}).then(res => {
        this.invoices = res
        this.$router.replace({name: this.$route.name, params: {lang: this.getLanguage}, query: {page: res.page_num}})
        this.loading = false
      })
    },
    toPage (page) {
      this.getData(page)
      this.currentPage = page
    },
    pay (id) {
      this.$router.push({name: 'Invoice', params: {lang: this.getLanguage}, query: {id: id}})
    },
    async cancel (id) {
      this.confirmModal = false
      await this.cancelInvoice({lang: this.getLanguage, invoice: id}).then(() => {
        toastr.success(gettext('Invoice canceled!'), gettext('Success!'))
      }).catch(() => {
        toastr.error(gettext('Invoice canceled!'), gettext('Error!'))
      })
      this.getData(this.currentPage)
    },
    expiredFormat (data) {
      let difference = Math.abs(moment(data).diff(moment(), 'days'))
      return interpolate(ngettext('%s day left', '%s days left', difference), [difference])
    },
    getDetail (id) {
      this.getBillingInvoiceDetail({lang: this.getLanguage, invoice: id}).then(res => {
        this.invoiceDetail = res
        this.detailsModal = true
      })
    },
    setAliases () {
      this.$set(this.aliases, CONSTANTS.CV_INVOICE_ITEM_NAME, gettext('CV contacts item'))
      this.$set(this.aliases, CONSTANTS.ACCOUNT_TOPUP_INVOICE_NAME, gettext('Account top up item'))
    },
    getAlias (alias) {
      let result = alias
      _.each(this.aliases, (item, key) => {
        if (item === alias) result = key
        else if (key === alias) result = item
      })
      return result
    },
    getStatus (invoice) {
      if (invoice.status.code === CONSTANTS.INVOICE_STATUS_PAYED && !invoice.payed) return gettext('in process')
      return invoice.status.name
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Bixter | ' + gettext('Cabinet invoices'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  },
  created () {
    this.setAliases()
    this.receiveCountries({lang: this.getLanguage}).then(res => {
      this.countries = res
    })
    this.getData(this.currentPage)
  }
}
</script>
<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/billing/cabinet/index.vue